import React, { useState, useEffect } from "react";
import { Route, Routes, useSearchParams } from "react-router-dom";
import { FileView } from "./FileView";

function ViewFolder(props) {
  const [searchParams] = useSearchParams();
  const [rootDir, setRootDir] = useState(searchParams.get("root_dir") || "");
  const [name, setName] = useState(searchParams.get("name") || "");
  const [path, setPath] = useState("");
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setRootDir(params.get("root_dir") || "");
    setName(params.get("name") || "");

    if (params.get("merge_type") === "stage") {
      const url = `/resources/listdir`;
      setPath(url);
    } else if (params.get("merge_type") === "vuz") {
      const url = `/resources/listdir/by_vuz`;
      setPath(url);
    }

    // Убираем очистку `path`
    return () => {
      // здесь можно выполнить любое другое действие при очистке, если необходимо
    };
  }, [window.location.search]);

  if (path) {
    return (
      <FileView
        path={path}
        setPath={setPath}
        dir={rootDir}
        title={name}
        icon="none"
      />
    );
  }
}

export default ViewFolder;
